import { Injectable } from '@angular/core';
import { BaseControl, Textbox, SedeEmpresa } from '@app/shared';
import { Validators } from '@angular/forms';

@Injectable()
export class SedesManagementFormService {

  constructor() { }

  /**
   * Construye y retorna el formulario para agregar y modificar sedes
   *
   * @param {SedeEmpresa} [sede]
   * @returns {BaseControl<any>[]}
   * @memberof SedesManagementFormService
   */
  getFormSede(sede?: SedeEmpresa): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'nombre',
        value: sede ? sede.nombre ? sede.nombre : null : null,
        label: 'Nombre',
        placeholder: 'Nombre de la sede',
        order: 1,
        validations: {
          validators: [Validators.required]
        }
      }),

      new Textbox({
        key: 'descripcion',
        value: sede ? sede.descripcion ? sede.descripcion : null : null,
        label: 'Descripción',
        placeholder: 'Descripción de la sede',
        order: 2,
        validations: {
          validators: [Validators.required]
        }
      }),

      new Textbox({
        key: 'nombre_corto',
        value: sede ? sede.nombre_corto ? sede.nombre_corto : null : null,
        label: 'Nombre corto',
        placeholder: 'Nombre corto de la sede',
        order: 3,
      }),

      new Textbox({
        key: 'codigo',
        value: sede ? sede.codigo ? sede.codigo : null : null,
        label: 'Código',
        placeholder: 'Código de la sede',
        order: 4,
        validations: {
          validators: [Validators.required]
        }
      })
    ];
    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-system/sedes-management/shared/sedes-management-form.service.ts